import getTrafficSource from '../url/getTrafficSource';
/**
 * Update the text content of an element based on the current traffic source
 * @param {'avm' | 'hb' | 'sem' | 'pub'} trafficSource - The traffic source to update the text content for
 * @param {string} selector - The selector of the element to update the text content for
 * @param {string} newText - The new text content to update the element with
 */
export default function updateTextContentByTrafficSource(trafficSource, selector, newText) {
	const validTrafficSources = ['avm', 'hb', 'sem', 'pub'];

	if (!validTrafficSources.includes(trafficSource)) {
		console.warn(`Invalid traffic source: ${trafficSource}\nMust be one of: ${validTrafficSources.join(', ')}`);
		return;
	}

	if (typeof selector !== 'string' || !selector.trim()) {
		console.warn(`Invalid selector: ${selector}\nMust be a non-empty string`);
		return;
	}

	if (typeof newText !== 'string' || newText.trim() === '') {
		console.warn('newText is required and must be a non-empty string');
		return;
	}

	const currentTrafficSource = getTrafficSource();

	if (currentTrafficSource === trafficSource) {
		const $element = document.querySelector(selector);

		if (!$element) {
			console.warn(`Element not found: ${selector}\nCould not update text content for traffic source: ${trafficSource}`);
			return;
		}

		$element.textContent = newText;
	}
}
